import React from "react";

const FolderIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.8492 13.61C17.8492 16.5917 16.0917 18.3492 13.11 18.3492H6.625C3.63583 18.3492 1.875 16.5917 1.875 13.61V7.11C1.875 4.1325 2.97 2.375 5.9525 2.375H7.61917C8.2175 2.37583 8.78083 2.65667 9.13917 3.13583L9.9 4.1475C10.26 4.62583 10.8233 4.9075 11.4217 4.90833H13.78C16.7692 4.90833 17.8725 6.43 17.8725 9.4725L17.8492 13.61Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.23438 12.5524H13.5135"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FolderIcon;
